import { createFileRoute } from '@tanstack/react-router'
import { InvoicesPage } from '@/features/billing/invoices-page'
import { requirePermission } from '@/lib/route-guards'

/** Facturas electrónicas (FEL): listado con estado, reintentos y descarga del XML. */
export const Route = createFileRoute('/_app/billing/')({
  beforeLoad: requirePermission('billing:read'),
  component: InvoicesPage,
})
